import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-loading-full-screen',
  templateUrl: './loading-full-screen.page.html',
  styleUrls: ['./loading-full-screen.page.scss'],
})
export class LoadingFullScreenPage implements OnInit {
  @Input() loadingText = '';

  constructor() { }

  ngOnInit() {
  }

}
